import React from 'react'
import {IconProps} from 'types/IconProps'

const ExternalLink = ({size = 24}: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
    <defs>
      <filter id="prefix__a" colorInterpolationFilters="auto">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.415686 0 0 0 0 0.470588 0 0 0 0 0.525490 0 0 0 1.000000 0"
        />
      </filter>
      <filter id="prefix__b" colorInterpolationFilters="auto">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.415686 0 0 0 0 0.470588 0 0 0 0 0.525490 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g
      filter="url(#prefix__a)"
      transform="translate(-320 -423)"
      fill="none"
      fillRule="evenodd"
    >
      <g filter="url(#prefix__b)" transform="translate(320 423)">
        <g fill="#000" fillRule="nonzero">
          <path d="M12.889 4l2.927 2.927-6.222 6.222 1.257 1.257 6.222-6.222L20 11.111V4z" />
          <path d="M18.222 18.222H5.778V5.778H12L10.222 4H5.778A1.78 1.78 0 004 5.778v12.444C4 19.202 4.797 20 5.778 20h12.444A1.78 1.78 0 0020 18.222v-4.444L18.222 12v6.222z" />
        </g>
      </g>
      <path d="M320 423h24v24h-24z" />
    </g>
  </svg>
)

export default ExternalLink
